export const EMPTY_STATE_ZERO_REVIEWS_TITLE = 'es-zero-reviews-title';
export const EMPTY_STATE_ZERO_REVIEWS_CONTENT = 'es-zero-reviews-content';
export const EMPTY_STATE_CTA = 'es-zero-reviews-cta';
